var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from "axios";
import { API_GET_ACTIVE_ROOMS, API_GET_LOBBY_INFO, API_GET_WHITEBOARD_HISTORY, API_POST_CREATE_WHITEBOARD, API_POST_WHITEBOARD_MESSAGE, API_WHITEBOARD_UNREAD_MSG, API_WHITEBOARD_HOT_ROOM, API_POST_WHITEBOARD_MESSAGE_REACTION, API_POST_WHITEBOARD_VOICE_TRANSCRIBE, } from ".";
export const getWhiteboardItem = (api, id) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const response = yield api.get(API_GET_LOBBY_INFO + id);
        return response.data;
    }
    catch (error) {
        if (axios.isAxiosError(error)) {
            const serverResponse = error.response;
            if (serverResponse && serverResponse.status === 404) {
                throw new Error("lobby not found");
            }
        }
        throw new Error("server error");
    }
});
export const getWhiteboards = (api, params) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        if (!params.order)
            params.order = "default";
        const response = yield api.get(API_GET_ACTIVE_ROOMS + params.domain, {
            params: { order: params.order },
        });
        const dataWithUrl = response.data.filter((room) => room.url);
        return dataWithUrl;
    }
    catch (err) {
        console.error(`Failed to get whiteboards, reason:(${err.message})`);
        return [];
    }
});
export const getWhiteboardMessagesHistory = (api, params) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        return yield api.get(API_GET_WHITEBOARD_HISTORY, {
            params,
        });
    }
    catch (err) {
        return {};
    }
});
function postWhiteboardMessage(api, room, data) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield api.post(API_POST_WHITEBOARD_MESSAGE + `${room}`, data);
    });
}
export function createWhiteboard(api, room, roomDomain, roomUrl) {
    return __awaiter(this, void 0, void 0, function* () {
        const whiteboardPayload = {
            domain: roomDomain,
            url: roomUrl,
            hashed_domain: room,
        };
        return yield api.post(API_POST_CREATE_WHITEBOARD, whiteboardPayload);
    });
}
function handleWhiteboardError(api, err, room, data, roomDomain, roomUrl) {
    return __awaiter(this, void 0, void 0, function* () {
        if (err.response &&
            err.response.status === 400 &&
            err.response.data &&
            err.response.data.code === 5101) {
            try {
                if (!roomUrl)
                    throw new Error("roomUrl is not provided");
                // create whiteboard
                yield createWhiteboard(api, room, roomDomain, roomUrl);
                // resend message
                yield postWhiteboardMessage(api, room, data);
            }
            catch (innerErr) {
                console.error(`Failed to send message, reason:(${innerErr.message})`);
            }
        }
        else {
            console.error(`Failed to send message, reason:(${err.message})`);
        }
    });
}
export const postWhiteBoardMessage = (api, data, room, roomDomain, roomUrl) => __awaiter(void 0, void 0, void 0, function* () {
    // TODO: use only roomUrl, or maybe delete roomDomain
    if (!room || !roomDomain)
        return;
    try {
        yield postWhiteboardMessage(api, room, data);
    }
    catch (err) {
        handleWhiteboardError(api, err, room, data, roomDomain, roomUrl);
    }
});
export const getUnreadWhiteboardMessages = (api, room) => {
    return api.get(API_WHITEBOARD_UNREAD_MSG, {
        params: { hashed_domain: room },
    });
};
export const getHotRooms = (api, room, domain) => {
    return api.get(API_WHITEBOARD_HOT_ROOM, {
        params: { hashed_domain: room, domain: domain },
    });
};
export const postWhiteBoardMessageReaction = (api, room, messageId, reaction) => __awaiter(void 0, void 0, void 0, function* () {
    return yield api.post(`${API_POST_WHITEBOARD_MESSAGE_REACTION}${room}/${messageId}`, {
        reaction,
    });
});
export const postVoiceTranscribe = (api, audioBlob) => __awaiter(void 0, void 0, void 0, function* () {
    const formData = new FormData();
    formData.append("audio", audioBlob);
    const res = yield api.post(API_POST_WHITEBOARD_VOICE_TRANSCRIBE, formData, {
        headers: {
            "Content-Type": "multipart/form-data", // This is usually required for FormData with Axios
        },
    });
    if (res.status === 200) {
        return res.data.text;
    }
    console.error("Failed to transcribe voice");
    return "";
});
//# sourceMappingURL=whiteboard.js.map